import PieChart from './PieChart';

export default PieChart;
export * from './PieChart';
